import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { Redirect } from "react-router-dom";
import { compose } from "redux";
import { Button, Grid, Icon, Loader, Popup } from "semantic-ui-react";
import Input from "../../components/customInputs/CustomText";
import Password from "../../components/customInputs/Password";
import SignUpGuideLine from "../../components/modal/SignUpGuideLine";
import { handleNewUser } from "../../store/actions/newSignup";
import { emailRegex } from "../../utils/regex";
import "./Signup.css";

const NewSignup = (props) => {
  const [error, setError] = useState(null);
  const [emailerror, setEmailerror] = useState(null);
  const [email, setEmail] = useState(null);
  const [password, setPassword] = useState(null);
  const [fname, setFName] = useState(null);
  const [lname, setLName] = useState(null);
  const dispatch = useDispatch();

  const handleCreateNewUser = () => {
    if (!error && !emailerror && fname && lname && email && password) {
      const data = {
        fname,
        lname,
        email,
        password,
      };
      dispatch(handleNewUser(data));
    } else {
      !email && setEmailerror(true);
      !password && setError("Enter valid password");
      !fname && setError("First name is required");
      !lname && setError("Last name is required");
      !email &&
        !password &&
        !fname &&
        !lname &&
        setError("All fields are required");
    }
  };

  useEffect(() => {
    if (
      props.emails &&
      props.emails.length > 0 &&
      email &&
      props.emails.includes(email) &&
      !props.signedUp
    ) {
      setEmail(null);
      setEmailerror(true);
    }
    if (
      props.emails &&
      props.emails.length > 0 &&
      email &&
      !props.emails.includes(email)
    ) {
      setEmailerror(null);
    }
  }, [email, props.emails, error]);

  if (props.emails && (props.emails.length < 0 || !props.auth.isLoaded)) {
    return (
      <div className="SpinnerBackground">
        <div className="SpinnerContainer">
          <Loader size="large" active inline="centered" />
        </div>
      </div>
    );
  } else if (
    props.auth.isLoaded &&
    !props.auth.isEmpty &&
    props.superAdmin === false
  ) {
    return <Redirect to={`/admin/${props.auth.uid}`} />;
  } else if (props.superAdmin && props.auth.isLoaded) {
    return <Redirect to="/super-admin/" />;
  } else if (
    props.emails &&
    props.emails.length > 0 &&
    props.auth.isEmpty &&
    props.auth.isLoaded
  ) {
    return (
      <div className="signupSpacecontainer signup-main">
        <div className="signup-container">
          <div className="header-text">
            <h1>Sign Up</h1>
            <div className="card signup-card wModal">
              <SignUpGuideLine />
              <div className="card-body signup-card-body">
                <div className="step-header">
                  <h2 className="step-header-head">Welcome to CSA</h2>
                  {error && <p className="errorText">{error}</p>}
                  {emailerror && <p className="errorText">Invalid Email</p>}
                </div>
                <Grid divided="vertically">
                  <Grid.Row stackable="true">
                    <Grid.Column mobile={16} tablet={16} computer={16}>
                      <div className="form-group">
                        <label htmlFor="email">
                          Athlete's Email{" "}
                          <Popup
                            content="This will be used for Authentication Purposes"
                            trigger={<Icon name="question circle" />}
                          />
                          <span className="required">*</span>
                        </label>
                        <input
                          id="email"
                          type="text"
                          placeholder="Enter Email"
                          autoComplete="off"
                          onChange={(e) =>
                            emailRegex.test(e.target.value) &&
                            setEmail(e.target.value)
                          }
                        />
                      </div>
                    </Grid.Column>
                    <Input
                      getError={(e) => setError(e)}
                      getValue={(e) => setFName(e)}
                      name="Athlete's First Name"
                    />
                    <Input
                      getError={(e) => setError(e)}
                      getValue={(e) => setLName(e)}
                      name="Athlete's Last Name"
                    />

                    <Password
                      getError={(e) => setError(e)}
                      getValue={(e) => setPassword(e)}
                    />
                  </Grid.Row>
                </Grid>
                <div className="footer-btn-data single">
                  <Button
                    primary
                    disabled={error || emailerror}
                    loading={props.signingUp}
                    onClick={() => {
                      handleCreateNewUser();
                    }}
                  >
                    Sign Up
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  } else
    return (
      <div className="SpinnerBackground">
        <div className="SpinnerContainer">
          <Loader size="large" active inline="centered" />
        </div>
      </div>
    );
};

const mapStateToProps = (state) => {
  const emails = [];
  const advocatesData = state.firestore.ordered.advocates;
  const newRequestsData = state.firestore.ordered.testNewRequests;
  newRequestsData &&
    newRequestsData.length > 0 &&
    newRequestsData.forEach((data) => data.email && emails.push(data.email));
  advocatesData &&
    advocatesData.length > 0 &&
    advocatesData.forEach((data) => data.email && emails.push(data.email));
  return {
    emails,
    auth: state.firebase.auth,
    superAdmin: state.auth.superAdmin,
    signingUp: state.signup.signupAdding,
    signedUp: state.signup.signupAdd,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect([
    {
      collection: "advocates",
    },
    {
      collection: "testNewRequests",
    },
    {
      collection: "adminAthletes",
    },
  ])
)(NewSignup);
